import { createSlice } from "@reduxjs/toolkit";
export type ViewType = "table" | "card" | "detail";

const initialState: { data: ViewType } = {
  data: "table",
};

export const AllProjectsListViewTypeSlice = createSlice({
  name: "allProjectsListViewType",
  initialState,
  reducers: {
    updateAllProjectsListViewType(state, action) {
      state.data = action.payload;
    },
  },
});
export const { updateAllProjectsListViewType } =
  AllProjectsListViewTypeSlice.actions;

